import Contextualable from '../../mixins/contextualable'

export default {
  name: 'chip',
  functional: true,
  mixins: [Contextualable],

  props: {
    tag: { type: String, default: 'small' },
    round: { type: Boolean },
    skew: { type: Boolean },
  },

  render (h, { props, data, children }) {

    const classes = {
      ...Contextualable.computed.$contextualClasses.apply(props),
      chip: true,
      'chip--round': props.round,
      'chip--skew': props.skew,
    }

    const computed = Object.keys(classes).filter(k => classes[k]).join(' ')
    data.staticClass = data.staticClass ? `${data.staticClass} ${computed}` : computed

    return h(props.tag, data, children)
  }
}
